// Navigation des Moduls `pip` (eager geladen; Quelle UX §2.7, SPEC D10). Besitzer: Modul pip.
// People-App ohne Eintrag (UX A4, streng vertraulich). Admin: „PIP cases“ für HR; PERF, CL und CEO
// sehen dort nur Zahlen. ADM ohne weitere Rolle sieht den Bereich nicht (SPEC §1.4 D10).
import { Briefcase } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'pip',
  title: 'Underperformer & PIP',
  nav: {
    admin: [
      {
        key: 'pip.cases',
        label: 'PIP cases',
        icon: Briefcase,
        path: '/cases',
        roles: ['HR', 'PERF', 'CL', 'CEO'],
        order: 410,
        area: 'Cases',
        readOnly: ['PERF', 'CL', 'CEO'],
      },
    ],
  },
});
